var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H25C24.4477 8 24 8.44772 24 9V24C24 24.5523 24.4477 25 25 25H26",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H7.08789C7.64018 8 8.08789 8.44772 8.08789 9V24C8.08789 24.5523 7.64018 25 7.08789 25H6",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0879 9L12.0879 24C12.0879 24.5523 12.5356 25 13.0879 25H19.0879C19.6402 25 20.0879 24.5523 20.0879 24V9C20.0879 8.44772 19.6402 8 19.0879 8H13.0879C12.5356 8 12.0879 8.44772 12.0879 9Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.c3dab62cdbe03ec879245cffbf97bd24.svg";
export { ForwardRef as ReactComponent };